import { Button, CssBaseline, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles';
import { Container } from '@mui/system'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { db } from '../../firebase';
import emailjs from '@emailjs/browser';

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(3, 0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  root: {
   
    justifyContent: 'center',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    padding: theme.spacing(1.5),
  },
  checkboxLabel: {
      fontSize: 12
  }
}));
function Method() {
  const classes = useStyles();
  const history = useNavigate()
  let {id} = useParams()
  const generatePassword = (len) => {
    let result = [];
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@-%$#!&+?';
    const charLength = characters.length;
    for (let i = 0; i < len; i++) {
        result.push(characters.charAt(Math.floor(Math.random() * charLength)));
    }
    return result.join('');
}
  return (
     <div className={classes.root}>
        <Container component="main" maxWidth="xs" className="card">
            <CssBaseline />
            <div className={classes.paper}>
                <Typography component="h5" variant="h6">
                Two Factor Authentication
                </Typography>
                <p  style={{textAlign:"center"}}>How would you like to receive your otp?</p>
                <form className={classes.form} noValidate>
                   <div style={{display:'flex', justifyContent:'space-between'}}></div>
                    <Button
                        type="submit"
                        fullWidth
                        variant="outlined"
                        color="primary"
                        size="large"
                        onClick={(e)=>{
                            e.preventDefault()
                            let otp = generatePassword(5);
                             db.collection('users').doc(id).get().then(function(snapshot) {
                 var templateParams = {
                    email: snapshot.data().email,
                    subject: 'Two Factor Authentication',
                    message: 'OTP: '+ otp,
                    comp_name: 'Dev Arena'
                   
                 };
         emailjs.send("service_oiqb0bo","template_ntw8bxg",templateParams,"wwlXdyG0epB_-bxgu")
            .then(function(response) {
                db.collection('users').doc(id).update({
                code: otp
              });
                history('/2fa/'+id)
            }, function(error) {
              console.log(error)
            }); 
               })
                }}
                        >
                        Email
                    </Button>
                    <Button
                        type="submit"
                        fullWidth
                        variant="outlined"
                        color="primary"
                        size="large"
                        onClick={()=>{history('/2fa/'+id)}}>
                        Text
                    </Button>
                </form>
            </div>
        </Container>
      </div>
  )
}

export default Method